/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { createCheckoutSession, getCoupons, getPlans } from "../core/_requests";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadStripe } from '@stripe/stripe-js';
import { Button, Modal } from "react-bootstrap";
import { ProfileDetails } from "../../settings/core/_requests";
import OfferBanner from "./OfferText";
import PaymentModal from "./PaymentModal";
import Checkoutsection from "./SubscriptionModal";
import { ActivePlanDetails, Plan, PlanDetail } from "../core/_models";
import { Tooltip } from "bootstrap";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CustomTooltip from "./CustomTooltip";



interface PlanType {
  uuid: string;
  planTypeName: string;
}
interface FeatureDetail {
  id: number;
  name: string;
  description: string;
}

const ListPlans = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState<Plan[]>([]);
  const [subscribedActivePlan, setSubscribedActivePlan] = useState<Plan | null | any>(null);
  const [subscribingPlan, setSubscribingPlan] = useState<string | null>(null);
  const [selectedPlanOption, setSelectedPlanOption] = useState<{ [key: string]: PlanDetail | null | any }>({});

  const [walletBalance, setWalletBalance] = useState<any>();
  const [showSubscribeConformationModal, setShowSubscribeConformationModal] = useState(false);
  const [walletInputAmount, setWalletInputAmount] = useState<number>(0);
const [coupons, setCoupons] = useState<any>({});
  const [offerDescription, setOfferDescription] = useState<any>("");
  const [offerText, setOfferText] = useState<any>("");
  const [offerAmount, setOfferAmount] = useState<any>("");
  const [offerToday, setOfferToday] = useState<boolean>(false);
 const { id: urlid } = useParams();
const chefId = urlid || currentUser?.uuid;

console.log("Chef ID:", chefId);
  useEffect(() => {
    if (chefId) {
      localStorage.setItem("chefId", chefId);
      console.log("Chef ID stored:", chefId);
    }
  }, [chefId]);
  useEffect(()=>{
    if(urlid){
       localStorage.setItem("params", '1' );
    }
  },[urlid])

  useEffect(() => {
    ProfileDetails(chefId).then((res) => {
      const balance = res.data?.walletBalance || 0;
      setWalletBalance(balance * 0.8); // Set to 20% of the returned balance
    });
  }, [chefId]); // Add chefId as a dependency if it might change



  // Check for the environment variable and ensure it's a string
  if (!process.env.REACT_APP_STRIPE_PUBLIC_KEY) {
    throw new Error('Stripe public key is not defined');
  }
  const [activeFeatureId, setActiveFeatureId] = useState<number | null>(null);
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  const [showSubscribeModal, setShowSubscribeModal] = useState(false);

  const [activePlanDetails, setActivePlanDetails] = useState<ActivePlanDetails>({
    id: '',
    name: '',
    amount: '',
    type: 0,
    validity: '',
    button: '',
    plan_end_date: '',
    plan_start_date: '',
    yearDifferenceAmount: '',
    monthDifferenceAmount: '',
    description: '',
    plan_details: [],
  });
const handleShowSubscribeModal = (plan: any) => {
  if (!selectedPlanOption[plan.id]) {
    toast.error("Pick a Plan First – Then Hit Subscribe!");
    return;
  }

  // Send only the selected detail for this plan
  const selectedDetail = selectedPlanOption[plan.id];

 navigate("/subscription/details", {
    state: {
      plan,                   // full plan details
      selectedDetail,          // selected plan option
      walletBalance,           // user wallet balance
      offerToday,              // is there an active offer today
      offerAmount,             // calculated offer amount (after discount)
      offerText,               // text to display discount info
      couponId: coupons?.primaryId || null,  // coupon id if any
      paymentType,             // current selected payment type
      walletInputAmount,       // amount user wants to use from wallet
    },
  });
};

  const handleCloseSubscribeModal = () => {
    setShowSubscribeModal(false);

    // Check if walletBalance is not zero, then show confirmation modal
    if (walletBalance > 1) {
      setShowSubscribeConformationModal(true);
    }
  };
  const handleCloseSubscribeConformationModal = () => {
    setWalletInputAmount(0)
    setShowSubscribeConformationModal(false);

  };
  const [paymentType, setPaymentType] = useState<any>(2);

  const fetchPlans = async () => {
    try {

      const res = await getPlans(chefId);

      const plansData: Plan[] = res?.data || []; // Specify the type for plansData
      setPlans(plansData);

      const activePlans = plansData.filter((plan: Plan) => plan.isPlanActive); // Filter active plans

      const initialSelectedOptions: { [key: string]: PlanDetail | null } = {}; // Ensure the type is specified

      activePlans.forEach((activePlan: Plan) => { // Loop through active plans
        setSubscribedActivePlan(activePlan);

        // Attempt to find the active detail first
        const activeDetail = activePlan.plan_details.find((detail: PlanDetail) => detail.isActive);
        // If no active detail found, fall back to the first detail
        const selectedDetail = activeDetail || activePlan.plan_details[0];
        if (selectedDetail) {
          initialSelectedOptions[activePlan.id] = {
            amount: selectedDetail.amount,
            validity: selectedDetail.validity,
            validityCount: selectedDetail.validityCount,
            type: selectedDetail.type,
            isActive: selectedDetail.isActive,
          };


        }
      });


    } catch (error) {
      console.error("Error fetching plans:", error);
    } finally {
      setLoading(false);

    }
  };


  useEffect(() => {
    fetchPlans();
  }, []);

  useEffect(() => {
    if (subscribedActivePlan?.id) {
      ;
    }
  }, [subscribedActivePlan]);

  useEffect(() => {
    if (subscribedActivePlan?.id) {
      localStorage.setItem("subscribedPlanId", subscribedActivePlan.id);

    }
  }, [activePlanDetails, walletBalance, selectedPlanOption]);

  useEffect(() => {
    fetchPlans();
    fetchCoupons();
  }, []);

  const handlePlanOptionChange = (planId: any, amount: any, validity: any, validityCount: any, type: any, isActive: any) => {


    setSelectedPlanOption((prevState) => {
      const newState = { ...prevState };

      // Uncheck all other plans first, only if they are not active
      Object.keys(newState).forEach((key) => {
        if (key !== planId && newState[key]?.isActive === false) {
          newState[key] = null; // Uncheck other plans that are not active
        }
      });

      // Calculate offerText and offerAmount based on coupon type
      if (offerToday && (coupons?.planId==="00000000-0000-0000-0000-000000000000" || coupons?.planId===planId)) {
        if (coupons.couponValueType === 1) { 
          // Percentage discount
          const discount = amount - (amount * coupons.amount) / 100;
          setOfferAmount(discount.toFixed(2));
          setOfferText(
            `(${coupons.amount}% off, new price $${discount.toFixed(2)})`
          );
        } else if (coupons.couponValueType === 2) {
          // Fixed amount discount
          const discount = amount - coupons.amount;
      
          setOfferAmount(discount.toFixed(2));
          setOfferAmount(discount.toFixed(2));
          setOfferText(
            `($${coupons.amount} off, new price $${discount.toFixed(2)})`
          );
        } else {
          // No discount
          
          setOfferAmount(null);
          setOfferText(null);
        }
      }
  else {
          // No discount
          
          setOfferAmount(null);
          setOfferText(null);
        }
      // Set the selected plan option and the calculated offer amount
      newState[planId] = { amount, validityCount, validity, type, isActive };

      return newState;
    });
  };

  useEffect(() => {
    const selectedPlanAmount = offer
      ? offerAmount
      : selectedPlanOption[activePlanDetails?.id || ""]?.amount || 0;

    if (walletBalance >= selectedPlanAmount) {
      // Wallet covers full amount
      setWalletInputAmount(selectedPlanAmount);
      setPaymentType(1);
    } else {
      // Partial wallet payment + card
      setWalletInputAmount(walletBalance);
      setPaymentType(3);
    }
  }, [activePlanDetails, walletBalance, selectedPlanOption]);

  
const fetchCoupons = async () => {
  try {
    const response = await getCoupons(2);
    

    if (response?.data && Array.isArray(response.data) && response.data.length > 0) {
      setCoupons(response.data[0]); // first coupon
    } else {
      setCoupons(null); // or []
      console.warn("No coupons found in response");
    }
  } catch (error) {
    console.error("Error fetching coupons:", error);
    setCoupons(null);
  }
};

useEffect(() => {
  if (!coupons || !coupons.startDate || !coupons.endDate) {
    setOfferDescription(null);
    return;
  }

  const now = new Date();
  const todayDate = new Date(
    now.toLocaleString("en-US", { timeZone: "America/New_York" })
  );

  const startDate = new Date(coupons.startDate);
  const endDate = new Date(coupons.endDate);

  if (todayDate >= startDate && todayDate <= endDate) {
    setOfferToday(true);
    const formattedDate = endDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
    });

    setOfferDescription(
      `Save – ${coupons.amount}${coupons.couponValueType === 1 ? "%" : "$"} ${
        coupons.planId !== "00000000-0000-0000-0000-000000000000"
          ? `on ${coupons.plan} plan`
          : ""
      } your chef subscription – Offer Ends ${formattedDate}.`
    );
  } else {
    setOfferDescription(null);
  }
}, [coupons]);


  const offer =
    offerToday &&
    offerAmount;

  const handleSubscribe = async (planId: string) => {


    if (!selectedPlanOption[planId]) {
      toast.error(" Pick a Plan First – Then Hit Subscribe!");
      return;
    }

    const selectedOption = selectedPlanOption[planId]!;
    const { amount, validityCount, type } = selectedOption;



    let effectivePaymentType = paymentType; // Use the selected payment type
    let finalAmount = offer ? offerAmount : amount;
    let finalWalletInputAmount = 0;

    if (paymentType === 1) {
      // Wallet payment selected
      if (walletInputAmount <= walletBalance && walletBalance != 0) {
        if (walletInputAmount >= finalAmount) {
          // Fully paid with wallet
          effectivePaymentType = 1;
          finalWalletInputAmount = finalAmount;
          // finalAmount = 0;
        } else {
          // Partial payment with wallet and card
          effectivePaymentType = 3;
          finalWalletInputAmount = walletInputAmount;
          finalAmount = finalAmount - walletInputAmount;
        }
      } else {
        // Invalid wallet input amount
        toast.error(
          "Entered wallet amount exceeds available wallet balance.",
          { autoClose: 5000 }
        );
        return;
      }
    } else if (paymentType === 2) {
      // Card payment selected
      effectivePaymentType = 2; // Fully paid with card
      finalWalletInputAmount = 0; // No wallet amount used
    }

    const parsedAmount = parseInt(finalAmount)

    // Validation to ensure the total amounts match
    const expectedTotal = type === 1 ? parsedAmount : amount; // Use discounted amount if applicable
    // if (finalWalletInputAmount + parsedAmount !== expectedTotal) {
    //   toast.error(
    //     "Calculation error: total payment does not match selected plan amount.",
    //     { autoClose: 5000 }
    //   );
    //   return;
    // }

    setSubscribingPlan(planId);
    handleCloseSubscribeModal();
    handleCloseSubscribeConformationModal();

    try {
      const sessionData = await createCheckoutSession({
        planId,
        originalAmount: amount,
        amount: parsedAmount,
        chefId,
        type,
        validity: validityCount,
        paymentType: effectivePaymentType,
        walletInputAmount: finalWalletInputAmount,
        ...(offer && { coupon_id: coupons?.primaryId }),
      });


      if (sessionData.status === true) {
        toast.success(sessionData.message, { autoClose: 5000 });
        setSelectedPlanOption({});
        fetchPlans();
      } else {
        toast.error(sessionData.message, { autoClose: 5000 });
      }

      const stripe = await stripePromise;

      if (stripe) {
        localStorage.setItem("sessionId", sessionData.id);
        const { error } = await stripe.redirectToCheckout({
          sessionId: sessionData.id,
        });
        if (error) {
          toast.error("Error processing payment. Please try again.", {
            autoClose: 5000,
          });
        }
      }
    } catch (error) {
      console.error("Error during subscription/payment process:", error);
    } finally {
      setSubscribingPlan(null);
    }
  };

  const handleInfoClick = (id: number) => {
    setActiveFeatureId((prevId) => (prevId === id ? null : id)); // Toggle the tooltip
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    const tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => {
      return new Tooltip(tooltipTriggerEl, {
        html: true,
        trigger: 'click', // Ensure it hides on blur
      });
    });

    // Clean up tooltips on component unmount
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);

 
  return (
    <section className="container-fluid">
      <div className="row">
        {/* Confirmation of wallet or payment using card to proceed payment */}

        <PaymentModal
          show={showSubscribeConformationModal}
          setShow={setShowSubscribeConformationModal}
          selectedPlanOption={selectedPlanOption}
          activePlanDetails={activePlanDetails}
          offer={offer}
          offerAmount={offerAmount}
          walletBalance={walletBalance}
          paymentType={paymentType}
          setPaymentType={setPaymentType}
          walletInputAmount={walletInputAmount}
          setWalletInputAmount={setWalletInputAmount}
          handleSubscribe={handleSubscribe}
        />


        
        <section className="content-section">
          <section className="row main-content">
            <div className="title mb-3">
              <h3 className="mb-0">Plans to Fit Your Needs</h3>
              <OfferBanner offerText={offerDescription} />
            </div>
            <div className="plan-container row">
              {loading ? (
                <div className="col-12 text-center">Loading...</div>
              ) : plans?.length > 0 ? (
                plans?.map((plan: any, index: any) => (
                  <div key={plan?.id} className="col-lg-4 col-md-6 col-sm-12">
                    <div
                      className={`plan-box card p-4 mb-4 ${plan?.isPlanActive ? "bg-light-green" : ""
                        }`}
                    >
                      <div className="plan-header d-flex flex-column align-items-center">
                        {/* Display the logo in the center */}
                        {plan.icon ? (

                          <img
                            className="img-fluid mb-2"
                            src={plan?.icon}
                            alt="Frayo"
                            height="90px"
                            width="90px"
                          />
                        ) : null}


                        {/* Display the description below the logo */}
                        <h5 className="plan-type fs-12 text-success mb-0 fw-bold text-center mb-2">
                          {plan.name}
                          {plan.isPlanActive && (
                            <span className="badge bg-danger ms-3">Active</span>
                          )}
                        </h5>

                        {plan.description && (
                          <p
                            className="fs-12 text-center mt-2"
                            style={{ maxWidth: "500px" }}
                          >
                            {plan.description}
                          </p>
                        )}
                      </div>

                      {plan.isPlanActive &&
                        plan.plantype.planTypeName === "!Free Plan" && (
                          <div className="subscription-options mb-3">
                            <label
                              className="form-check-label fw-bold mt-2 badge bg-danger ms-9"
                              style={{
                                backgroundColor: "#f8d7da",
                                padding: "12px",
                                borderRadius: "12px",
                              }}
                            >
                              {plan?.plan_start_date && (
                                <span>
                                  Validity:{" "}
                                  {new Date(
                                    plan.plan_start_date
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })}{" "}
                                  to{" "}
                                  {new Date(
                                    plan.plan_end_date
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })}
                                </span>
                              )}
                            </label>
                          </div>
                        )}
                      {plan.plan_details.map((detail: PlanDetail) => (
                        <div key={detail.validity} className="form-check">
                          {plan.plantype.planTypeName === "Free Plan" ? (
                            <label
                              className="form-check-label fw-bold mt-2 badge bg-danger ms-6 mt-2"
                              style={{
                                padding: "0.6rem 1.0rem",
                                fontSize: "0.8rem",
                                borderRadius: "0.5rem",
                              }}
                            >
                              <span>
                                {plan.plantype.planTypeName}: ${detail.amount.toFixed(2)} for {detail.validity}
                              </span>
                            </label>
                          ) : (
                            <>
                              <input
                                type="radio"
                                id={`plan-${plan.id}-${detail.validity}`}
                                name={`plan-${plan.id}`} // Ensure unique name for each plan
                                value={detail.type}
                                className="form-check-input"
                                onChange={() => {
                                  handlePlanOptionChange(
                                    plan.id,
                                    detail.amount,
                                    detail.validity,
                                    detail.validityCount,
                                    detail.type,
                                    detail.isActive
                                  );
                                }}
                                // Check if it's the selected option or an active plan
                                checked={
                                  // (plan.isPlanActive === true && detail.isActive === true) ||
                                  selectedPlanOption[plan.id]?.type === detail.type}
                                disabled={plan.isPlanActive === true && detail.isActive === true}

                              />
                              <label
                                className={`form-check-label ${detail.type === 1 && detail.isActive ? "text-danger" : ""
                                  }`}
                                htmlFor={`plan-${plan.id}-${detail.validity}`}
                              >
                                ${detail.amount} for {detail.validity}
                                
                              </label>
                              {/* Render the $460 plan as disabled with red color if $39.99 is selected */}
                              {selectedPlanOption[plan.id]?.type === 2 && selectedPlanOption[plan.id]?.active === true && (
                                <input
                                  type="checkbox"
                                  id={`plan-${plan.id}-year`}
                                  checked
                                  disabled
                                  className="form-check-input"
                                  style={{
                                    borderColor: "red",
                                    backgroundColor: "#f8d7da",
                                  }}
                                />
                              )}
                            </>
                          )}
                        </div>
                      ))}


                      <div className="plan-details mt-3">
                        <strong className="text-danger">Features:</strong>
                        <ul className="list-unstyled">
                          {plan.featuresDetails.map((feature: any) => (
                            <li
                              key={feature.id}
                              className="d-flex align-items-center my-2"
                            >
                              <img
                                src="/assets/images/vector.png"
                                alt="tick"
                                className="me-2"
                                style={{ width: "15px", height: "15px" }}
                              />
                              <span
                                className="me-3"
                                style={{ fontSize: "14px", position: "relative", overflow: "visible", zIndex: 1, }}
                              >
                                {feature.name}&nbsp;
                                {feature.description && (

                                  <CustomTooltip content={`${feature.description}`}>
                                    <i
                                      className="material-symbols-outlined"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#333",
                                      }}
                                    >
                                      info
                                    </i>
                                  </CustomTooltip>

                                )}
                                {activeFeatureId === feature.id && (
                                   <div
    style={{
      background: "#fff",
      padding: "10px",
      borderRadius: "5px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      border: "1px solid #ccc",
      position: "absolute",
      top: "-110%",   // moves tooltip above the text
      left: "0",      // aligns with left of feature name
      whiteSpace: "nowrap",
      zIndex: 1000,   // ensure it appears on top
    }}
    dangerouslySetInnerHTML={{ __html: feature.description }}
  >
                                    {/* {`${feature.description}`} */}

                                  </div>
                                )}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>



                      {plan?.plantype?.planTypeName !== "Free Plan" && plan.button && (
                        <div className="col-lg-12 plan-footer d-flex justify-content-center align-items-center mt-0">
                          <button
                            className={`btn rounded-5 me-2 ${plan.button === "Upgrade"
                              ? "btn-outline-success"
                              : "btn-outline-danger"
                              }`}
                           onClick={() => {

                              handleShowSubscribeModal(plan);
                            }} 
                            disabled={subscribingPlan === plan?.id}
                          >
                            {subscribingPlan === plan?.id
                              ? "Processing..."
                              : plan.button}
                          </button>
                        </div>
                      )}

                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center">No plans available.</div>
              )}
            </div>

          </section>

        </section>
      </div>
    </section>
  );
};

export default ListPlans;